import React from 'react';
import { CommunicationHub, HasAccess } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const PurchaseOrderCommunicationHub = React.memo(() => {
  const { hasAccess } = useAccessControl();
  return (
    <HasAccess role={PERMISSIONS.notes.note.read}>
      <CommunicationHub
        entity={'PURCHASE_ORDER'}
        hasAccessToWrite={hasAccess(PERMISSIONS.notes.note.write)}
        hasAccessToOtherNoteWrite={hasAccess(PERMISSIONS.notes.other_note.write)}
        hasAccessToOtherNoteDelete={hasAccess(PERMISSIONS.notes.other_note.delete)}
      />
    </HasAccess>
  );
});
